module.exports = __webpack_public_path__ + "static/fluidkit-200111e76b11468fff0f6a9f9f6490cf.png";